import React, { useState, useEffect } from 'react';
import { getApplicantionInfo } from '../../common/utils/applicantionInfo';
import { numberFormat } from '../../common/constants/NumberFormat';
import MakeACall from '../../components/MakeACall/MakeACall';
import {
  callContainerClasses,
  textShadowNormal
} from './PersonalDiscussionForm.module.css';
import PhoneIcon from '@material-ui/icons/Phone';

function PDBasicInfo() {
  const [basicInfo, setBasicInfo] = useState(getApplicantionInfo().leadData);

  return (
    <div className="grid grid-cols-1 xsm:grid-cols-1  xl:grid-cols-4 lg:grid-cols-3 md:flex-row bg-blue-foam flex gap-3 flex-wrap p-3 rounded ">
      <div className="pb-1">
        <span className={`${textShadowNormal} text-black-1020 `}>Name :</span>
        <span
          className={`text-black-600 pl-2 pr-4 font-bold ${textShadowNormal}`}
        >
          {basicInfo?.leadName?.firstName}
        </span>
      </div>

      <div className="pb-1">
        <span className={` ${textShadowNormal} text-black-1020`}>
          Lead ID :
        </span>
        <span
          className={`text-black-600 pl-2 pr-4 font-bold ${textShadowNormal}`}
        >
          {basicInfo?.leadId}
        </span>
      </div>

      <div className="pb-1 flex items-center">
        <span className={`text-black-1020 ${textShadowNormal}`}>Mobile :</span>
        <span className="text-black-600 pl-2 pr-4 ">
          <MakeACall
            phoneNumber={basicInfo?.leadApplicantPhone}
            leadId={basicInfo?.leadId}
            applicantId={basicInfo?.leadMainApplicantId}
            PhoneNumberClasses="hidden"
            CustomIcon={PhoneIcon}
            phoneCallStyles={{
              color: '#0A4549',
              height: '18px',
              marginTop: '-3px',
              marginLeft: '-3px'
            }}
            callWrapperStyle={{
              height: ' 25px',
              width: '25px'
            }}
            callWrapperClasses="bg-white rounded-full shadow px-1 py-1 box-shadow"
            loadingWrapperClasses="-mt-1 -ml-1"
          />
        </span>
      </div>

      <div className="pb-1">
        <span className={`text-black-1020 ${textShadowNormal}`}>City :</span>
        <span
          className={`text-black-600 pl-2 pr-4 font-bold ${textShadowNormal}`}
        >
          {basicInfo?.propertyCity ? basicInfo?.propertyCity : '---'}
        </span>
      </div>

      <div className="pb-1">
        <span className={`text-black-1020 ${textShadowNormal}`}>
          Loan Type :
        </span>
        <span
          className={`text-black-600 pl-2 pr-4 font-bold ${textShadowNormal}`}
        >
          {basicInfo?.loanProduct ? basicInfo.loanProduct : '---'}
        </span>
      </div>

      <div className="pb-1">
        <span className={`text-black-1020 ${textShadowNormal}`}>
          Loan Amount :
        </span>
        <span
          className={`text-black-600 pl-2 pr-4 font-bold ${textShadowNormal}`}
        >
          ₹{basicInfo?.loanAmount ? numberFormat(basicInfo?.loanAmount) : 0}
        </span>
      </div>

      <div className="pb-1">
        <span className={`text-black-1020 ${textShadowNormal}`}>
          Assigned RM :
        </span>
        <span
          className={`text-black-600 pl-2 pr-4 font-bold ${textShadowNormal}`}
        >
          {`${basicInfo?.rmName?.firstName || '---'} ${basicInfo?.rmName
            ?.middleName || ''} ${basicInfo?.rmName?.lastName || ''}`}
        </span>
      </div>

      <div className="pb-1">
        <span className={`text-black-1020 ${textShadowNormal}`}>Status :</span>
        <span
          className={`text-black-600 pl-2 pr-4 font-bold ${textShadowNormal}`}
        >
          {`${basicInfo?.status || '---'}`}
        </span>
      </div>
      <div className="pb-1">
        <span className={`text-black-1020 ${textShadowNormal}`}>
          Sub Status :
        </span>
        <span
          className={`text-black-600 pl-2 pr-4 font-bold ${textShadowNormal}`}
        >
          {`${basicInfo?.subStatus || '---'}`}
        </span>
      </div>
      <div className="pb-1">
        <span className={`text-black-1020 ${textShadowNormal}`}>Source :</span>
        <span
          className={`text-black-600 pl-2 pr-4 font-bold ${textShadowNormal}`}
        >
          {`${basicInfo?.leadSource || '---'}`}
        </span>
      </div>
    </div>
  );
}
export default PDBasicInfo;
